var selectioCtrlDesk = document.querySelector(".store-selection-ctrl"),
  selectionListDesk = document.querySelector(".store-selection-list"),
  selectionListItemsDesk = document.querySelectorAll(".store-selection-list-item"),
  storeNameDesk = document.querySelector("#store--name"),
  storeSelectionButtonDesk = document.querySelector(
    ".store-selection-popup--button"
  ),
  storeURL = "self",
  visitingFrom = "AUS",
  visitingCur = "AUD",
  modalClose = document.querySelector(".store-selection-popup--close"),
  flagClass = "";

var storeChecked = localStorage.getItem("storeChecked");
var urlParam = location.search.indexOf("redirectFrom");
if (storeChecked || urlParam != -1) {
  document.querySelector(".store-selecetion-popup").style.display = "none";
}
if (urlParam != -1) {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  let store = urlParams.get("redirectFrom");
  store = store.replace("%20", "");
  localStorage.setItem("visitingFrom", store);
  localStorage.setItem("storeChecked", "true");
}
function rebuildSelectionListDesk(current) {
  selectionListItemsDesk.forEach(function (el) {
    if (current == el) {
      el.style.display = "none";
    } else {
      el.style.display = "block";
    }
  });
}

function showVisitingFrom() {
  var text = localStorage.getItem("visitingFrom");
  if (text != null) {
    document
      .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
      .forEach(function (el) {
        el.classList.remove(el.classList.item(1));
      });
    switch (text) {
      case "Australia":
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("au");
          });
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "AUS";
          });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.classList.add("au");
        });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.innerText = "Australia";
        });
        $(".store-selecetion-popup .store-selection-list-item.au").hide();
        visitingCur = "AUD";
        $(".countrynameselect").html("Australia");
        break;
      case "United Kingdom":
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("gbp");
          });
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "UK";
          });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.classList.add("gbp");
        });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.innerText = "United Kingdom";
        });
        $(".store-selecetion-popup .store-selection-list-item.gbp").hide();
        visitingCur = "GBP";
        $(".countrynameselect").html("United Kingdom");
        break;  
      case "New Zealand":
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("nz");
          });
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "NZ";
          });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.classList.add("nz");
        });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.innerText = "New Zealand";
        });
        $(".store-selecetion-popup .store-selection-list-item.nz").hide();
        visitingCur = "NZD";
        $(".countrynameselect").html("New Zealand");
        break;
      case "International":
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("int");
          });
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "INT";
          });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.classList.add("int");
        });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.innerText = "International";
        });
        $(".store-selecetion-popup .store-selection-list-item.int").hide();
        visitingCur = "USD";
        $(".countrynameselect").html("International");
        break;
      case "United States":
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("usd");
          });
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "USA";
          });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.classList.add("usd");
        });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.innerText = "United States";
        });
        $(".store-selecetion-popup .store-selection-list-item.us").hide();
        visitingCur = "USD";
        $(".countrynameselect").html("United States"); 
        break;
       case "Singapore":
         document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.classList.add("sgd");
          });
        document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.innerText = "SGP";
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.classList.add("sgd");
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.innerText = "Singapore";
          });
        $(".store-selecetion-popup .store-selection-list-item.sgd").hide();
        visitingCur = "SGD";
        break;  
          case "The Netherlands":
         document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.classList.add("euro");
          });
        document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.innerText = "EUR";
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.classList.add("euro");
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.innerText = "Netherlands";
          });
        $(".store-selecetion-popup .store-selection-list-item.euro").hide();
        visitingCur = "EUR";
        break;
        case "Europe":
         document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.classList.add("europe");
          });
        document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.innerText = "EUR";
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.classList.add("europe");
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.innerText = "Europe";
          });
        $(".store-selecetion-popup .store-selection-list-item.europe").hide();
        visitingCur = "EUR";
        break;
    }
  }else{
     document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("usd");
          });
        document
          .querySelectorAll(".store-selecetion-popup .visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "USA";
          });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.classList.add("usd");
        });
        document.querySelectorAll(".store-selecetion-popup .store-country").forEach(function (el) {
          el.innerText = "United States";
        });
        $(".store-selecetion-popup .store-selection-list-item.us").hide();
        visitingCur = "USD";
        $(".countrynameselect").html("United States");  
  }
}

function showSelectionPopup() {
  document.querySelector(".store-selecetion-popup").style.display = "flex";
}
selectioCtrlDesk.addEventListener("click", function () {
  if (selectionListDesk.classList.contains("is-open")) {
    selectionListDesk.classList.remove("is-open");
  } else {
    selectionListDesk.classList.add("is-open");
  }
});

selectionListItemsDesk.forEach(function (item) {
  item.addEventListener("click", function () {
    storeURL = item.getAttribute("data-link");
    selectionListDesk.classList.remove("is-open");
    storeNameDesk.classList = "";
    flagClass = item.classList[1];
    storeNameDesk.innerText = item.innerText;
    storeNameDesk.classList.add("store--name", flagClass);
    visitingFrom = item.innerText;
    visitingCur = item.getAttribute("data-currency");
    storeSelectionButtonDesk.innerText = `Go to ${item.innerText}`;
    rebuildSelectionListDesk(item);
    //console.log(flagClass +'==>'+ visitingCur)
  });
});

storeSelectionButtonDesk.addEventListener("click", function () {
  // if (storeURL == "self") {
  //   document.querySelector(".store-selecetion-popup").style.display = "none";
  //   localStorage.setItem("storeChecked", "true");
  //   localStorage.setItem("visitingFrom", visitingFrom);
  //   showVisitingFrom();
  // } else {
  //   window.location.href = `${storeURL}?redirectFrom=${visitingFrom}`;
  // }
  visitingFrom = $('#store--name').html().trim();
  if(visitingCur == 'AUD' || visitingCur == 'NZD'){
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://bhumi.com.au/?redirectFrom=${visitingFrom}`;
  }else if(visitingCur == 'EUR'){
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://www.bhumi-organic.com/?redirectFrom=${visitingFrom}`;
  }else if(visitingCur == 'GBP'){
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://www.bhumiorganic.co.uk/?redirectFrom=${visitingFrom}`;
  }else{
    document.querySelector(".store-selecetion-popup").style.display = "none";
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    $(".currency-selector-auto select").val(visitingCur);
    $(".currency-selector-auto form").submit();
  }
});

modalClose.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", "United States");
  document.querySelector(".store-selecetion-popup").style.display = "none";
});
document.addEventListener('showVisitingFrom', () => {
    showVisitingFrom();
});



